import React, { useState } from 'react';
import { XIcon, MenuIcon, PhoneIcon, ChevronDownIcon, LinkedinIcon, FacebookIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
import { Button } from './ui/Button';
interface MenuItem {
  title: string;
  url: string;
  badge?: string;
  children?: MenuItem[];
  onClick?: (e: React.MouseEvent) => void;
}
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [openMobileSection, setOpenMobileSection] = useState<string | null>(null);
  const handleMouseEnter = (dropdown: string) => setOpenDropdown(dropdown);
  const handleMouseLeave = () => setOpenDropdown(null);
  const toggleMobileSection = (section: string) => setOpenMobileSection(prev => prev === section ? null : section);
  const desktopMenuItems: MenuItem[] = [{
    title: 'Home',
    url: '/'
  }, {
    title: 'About',
    url: '',
    children: [{
      title: 'About Peak',
      url: '/AboutPeakMachineSales.html'
    }, {
      title: 'FAQ',
      url: '/FrequentlyAskedQuestions.html'
    }, {
      title: 'Industry News',
      url: '/ManufacturingIndustryNews.html'
    }]
  }, {
    title: 'Products',
    url: '',
    children: [{
      title: 'Product Lines',
      url: '',
      children: [{
        title: 'Used Machine Inventory',
        url: '/59m7/used-machines.html'
      }, {
        title: 'Fast Wire EDM – Moly Wire',
        url: '/EDMNetworkFastWire.html',
        badge: 'NEW'
      }, {
        title: 'Seibu America',
        url: '/SeibuWireEDM.html',
        badge: 'NEW'
      }, {
        title: 'EDM Network',
        url: '/EDMNetwork.html',
        badge: 'NEW'
      }, {
        title: 'Spinner Milling & Turning',
        url: '/SpinnerMachineTools.html'
      }, {
        title: 'Breton Machine Tools',
        url: '/BretonMachineTools.html'
      }, {
        title: 'Bodor Laser Cutting',
        url: '/BodorLaserCutting.html'
      }]
    }, {
      title: 'Categories',
      url: '',
      children: [{
        title: 'Used Machines',
        url: '/59m7/used-machines.html',
        children: [{
          title: 'Used CNC Machining Centers',
          url: '/59m7/used-machines/used-cnc-machining-centers.html'
        }, {
          title: 'Used EDM Machines',
          url: '/59m7/used-machines/used-edm-machines.html'
        }, {
          title: 'Used Chillers & Transformers',
          url: '/59m7/used-machines/used-chillers-transformers.html'
        }]
      }, {
        title: 'EDM',
        url: '/59m7/edm.html',
        children: [{
          title: 'Wire EDM',
          url: '/59m7/edm.html'
        }, {
          title: 'Sinker EDM',
          url: '/59m7/edm.html'
        }, {
          title: 'Driller EDM',
          url: '/59m7/edm.html'
        }]
      }, {
        title: 'CNC Milling',
        url: '/SpinnerMachineTools.html',
        children: [{
          title: '3 & 4-Axis',
          url: '/SpinnerMachineTools.html'
        }, {
          title: 'CNC Bridge Mill',
          url: '/ContactPeakMachineSales.html'
        }, {
          title: '5-Axis',
          url: '/SpinnerMachineTools.html'
        }, {
          title: '5-Axis Gantry',
          url: '/BretonMachineTools.html'
        }]
      }, {
        title: 'CNC Turning',
        url: '/SpinnerMachineTools.html',
        children: [{
          title: 'Ultra-Precision Turning',
          url: '/SpinnerMachineTools.html'
        }, {
          title: 'Universal Turning',
          url: '/SpinnerMachineTools.html'
        }, {
          title: 'Multi-Turret',
          url: '/SpinnerMachineTools.html'
        }]
      }, {
        title: 'Laser Cutting',
        url: '/59m7/laser.html',
        children: [{
          title: 'Laser Plate Cutting',
          url: '/BodorLaserCutting.html'
        }, {
          title: 'Laser Tube Cutting',
          url: '/BodorLaserCutting.html'
        }]
      }, {
        title: 'Automation',
        url: '/59m7/automation.html'
      }, {
        title: 'EDM Parts & Consumables',
        url: '/QuoteEDMConsumables.html'
      }]
    }]
  }, {
    title: 'Contact',
    url: '',
    children: [{
      title: 'Contact Us',
      url: '/ContactPeakMachineSales.html'
    }, {
      title: 'Selling Used EDM',
      url: '/SellingUsedEDM.html'
    }]
  }];
  const mobileMenuItems: MenuItem[] = [{
    title: 'Home',
    url: '/'
  }, {
    title: 'About',
    url: '',
    children: [{
      title: 'About Peak',
      url: '/AboutPeakMachineSales.html'
    }, {
      title: 'FAQ',
      url: '/FrequentlyAskedQuestions.html'
    }, {
      title: 'Industry News',
      url: '/ManufacturingIndustryNews.html'
    }]
  }, {
    title: 'Products',
    url: '',
    children: [{
      title: 'Product Lines',
      url: '',
      children: [{
        title: 'Used Machine Inventory',
        url: '/59m7/used-machines.html'
      }, {
        title: 'Fast Wire EDM – Moly Wire',
        url: '/EDMNetworkFastWire.html',
        badge: 'NEW'
      }, {
        title: 'Seibu America',
        url: '/SeibuWireEDM.html',
        badge: 'NEW'
      }, {
        title: 'EDM Network',
        url: '/EDMNetwork.html',
        badge: 'NEW'
      }, {
        title: 'Spinner Milling & Turning',
        url: '/SpinnerMachineTools.html'
      }, {
        title: 'Breton Machine Tools',
        url: '/BretonMachineTools.html'
      }, {
        title: 'Bodor Laser Cutting',
        url: '/BodorLaserCutting.html'
      }]
    }, {
      title: 'Categories',
      url: '',
      children: [{
        title: 'Used Machines',
        url: '/59m7/used-machines.html'
      }, {
        title: 'EDM',
        url: '/59m7/edm.html'
      }, {
        title: 'CNC Milling',
        url: '/SpinnerMachineTools.html'
      }, {
        title: 'CNC Turning',
        url: '/SpinnerMachineTools.html'
      }, {
        title: 'Laser Cutting',
        url: '/59m7/laser.html'
      }, {
        title: 'Automation',
        url: '/59m7/automation.html'
      }, {
        title: 'EDM Parts & Consumables',
        url: '/QuoteEDMConsumables.html'
      }]
    }]
  }, {
    title: 'Contact',
    url: '',
    children: [{
      title: 'Contact Us',
      url: '/ContactPeakMachineSales.html'
    }, {
      title: 'Selling Used EDM',
      url: '/SellingUsedEDM.html'
    }]
  }];
  const renderBadge = (badge?: string) => badge ? <span className="text-xs bg-orange text-white px-2 py-0.5 rounded ml-1" data-id="element-141">
        {badge}
      </span> : null;
  return <>
      <header className="sticky top-0 z-50 bg-white border-b border-gray-200" data-id="element-142">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
          <div className="flex items-center justify-between h-20" data-id="element-144">
            {/* Logo */}
            <a href="/" className="flex items-center" data-id="element-145">
              <img src="https://cdn.magicpatterns.com/uploads/5H82rnwCrH9dHxQ46pA82h/Peak_Machine_Sales_Home.png" alt="Peak Machine Sales Logo" className="block h-16 w-auto" data-id="element-146" />
            </a>

            {/* Desktop Menu */}
            <nav className="hidden lg:flex items-center space-x-6" data-id="element-147">
              {desktopMenuItems.map(item => {
              if (!item.children || item.children.length === 0) {
                return <a key={item.title} href={item.url} className="text-navy hover:text-orange transition-colors font-medium" data-id="element-148">
                      {item.title}
                    </a>;
              }
              const dropdownKey = item.title.toLowerCase();
              const isMegaMenu = item.children.some(child => child.children && child.children.length > 0);
              return <div key={item.title} className="relative" onMouseEnter={() => handleMouseEnter(dropdownKey)} onMouseLeave={handleMouseLeave} data-id="element-149">
                    <button className="flex items-center text-navy hover:text-orange transition-colors font-medium" data-id="element-150">
                      {item.title}
                      <ChevronDownIcon className="w-4 h-4 ml-1" data-id="element-151" />
                    </button>

                    {openDropdown === dropdownKey && <>
                        {isMegaMenu ? <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 w-[600px]" data-id="element-152">
                            <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-6" data-id="element-153">
                              <div className="grid grid-cols-2 gap-8" data-id="element-154">
                                {item.children.map(column => <div key={column.title} data-id="element-155">
                                    <h3 className="text-sm font-bold text-navy uppercase mb-3" data-id="element-156">
                                      {column.title}
                                    </h3>
                                    <div className="space-y-2" data-id="element-157">
                                      {column.children?.map(child => child.children && child.children.length > 0 ? <div key={child.title} data-id="element-158">
                                            <a href={child.url} className="block text-navy hover:text-orange transition-colors text-sm font-medium" data-id="element-159">
                                              {child.title}
                                            </a>
                                            <div className="ml-4 mt-1 space-y-1" data-id="element-160">
                                              {child.children.map(leaf => <a key={leaf.title} href={leaf.url} className="block text-gray-600 hover:text-orange transition-colors text-sm" data-id="element-161">
                                                  {leaf.title}
                                                </a>)}
                                            </div>
                                          </div> : <a key={child.title} href={child.url} onClick={child.onClick} className={`block text-navy hover:text-orange transition-colors text-sm ${child.badge ? 'font-medium' : ''}`} data-id="element-162">
                                            {child.title}{' '}
                                            {renderBadge(child.badge)}
                                          </a>)}
                                    </div>
                                  </div>)}
                              </div>
                            </div>
                          </div> : <div className={`absolute top-full ${dropdownKey === 'contact' ? 'right-0' : 'left-0'} pt-2 w-56`} data-id="element-163">
                            <div className="bg-white rounded-lg shadow-xl border border-gray-200 py-2" data-id="element-164">
                              {item.children.map(child => <a key={child.title} href={child.url} className="block px-4 py-2 text-navy hover:bg-gray-50 hover:text-orange transition-colors" data-id="element-165">
                                  {child.title}
                                </a>)}
                            </div>
                          </div>}
                      </>}
                  </div>;
            })}
            </nav>

            {/* Desktop Utility Cluster */}
            <div className="hidden lg:flex flex-col items-end space-y-2" data-id="element-166">
              <div className="flex items-center space-x-3" data-id="element-167">
                <a href="https://www.linkedin.com/company/peak-machine-sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="LinkedIn" data-id="element-168">
                  <LinkedinIcon className="w-4 h-4" data-id="element-169" />
                </a>
                <a href="https://www.facebook.com/PeakMachineSales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Facebook" data-id="element-170">
                  <FacebookIcon className="w-4 h-4" data-id="element-171" />
                </a>
                <a href="https://www.instagram.com/peak_machine_sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Instagram" data-id="element-172">
                  <InstagramIcon className="w-4 h-4" data-id="element-173" />
                </a>
                <a href="https://www.youtube.com/channel/UCG3x08N2riAd1G2e9-driYA" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="YouTube" data-id="element-174">
                  <YoutubeIcon className="w-4 h-4" data-id="element-175" />
                </a>
              </div>
              <div className="flex items-center space-x-4" data-id="element-176">
                <a href="tel:2483800871" className="flex items-center text-sm text-navy hover:text-orange transition-colors font-medium" aria-label="Call Peak Machine Sales" data-id="element-177">
                  <PhoneIcon className="w-4 h-4 mr-1" data-id="element-178" />
                  <span data-id="element-179">(248) 380-0871</span>
                </a>
                <Button variant="primary" href="/ContactPeakMachineSales.html" size="md" className="text-sm px-5 py-2" data-id="element-180">
                  Contact / Get a Quote
                </Button>
              </div>
            </div>

            {/* Mobile Top Bar */}
            <div className="flex lg:hidden items-center space-x-2" data-id="element-181">
              <a href="tel:2483800871" className="text-navy p-2" aria-label="Call Peak Machine Sales" data-id="element-182">
                <PhoneIcon className="w-5 h-5" data-id="element-183" />
              </a>
              <Button variant="primary" href="/ContactPeakMachineSales.html" size="md" className="text-xs px-3 py-2" data-id="element-184">
                Contact
              </Button>
              <button onClick={() => setIsMobileMenuOpen(prev => !prev)} className="text-navy p-2" aria-label="Toggle menu" data-id="element-185">
                {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-186" /> : <MenuIcon className="w-6 h-6" data-id="element-187" />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && <div className="lg:hidden py-4 border-t border-gray-200 max-h-[80vh] overflow-y-auto" data-id="element-188">
              <nav className="flex flex-col space-y-2" data-id="element-189">
                {mobileMenuItems.map(item => {
              if (!item.children || item.children.length === 0) {
                return <a key={item.title} href={item.url} className="text-navy hover:text-orange transition-colors font-medium py-2" data-id="element-190">
                        {item.title}
                      </a>;
              }
              const sectionKey = item.title.toLowerCase();
              const isSectioned = item.children.some(child => child.children && child.children.length > 0);
              return <div key={item.title} data-id="element-191">
                      <button onClick={() => toggleMobileSection(sectionKey)} className="flex items-center justify-between w-full text-navy hover:text-orange transition-colors font-medium py-2" data-id="element-192">
                        {item.title}
                        <ChevronDownIcon className={`w-4 h-4 transition-transform ${openMobileSection === sectionKey ? 'rotate-180' : ''}`} data-id="element-193" />
                      </button>

                      {openMobileSection === sectionKey && <>
                          {isSectioned ? <div className="ml-4 space-y-3 mt-2" data-id="element-194">
                              {item.children.map(section => <div key={section.title} data-id="element-195">
                                  <p className="text-xs font-bold text-gray-500 uppercase mb-2" data-id="element-196">
                                    {section.title}
                                  </p>
                                  <div className="space-y-2" data-id="element-197">
                                    {section.children?.map(leaf => <a key={leaf.title} href={leaf.url} onClick={leaf.onClick} className={`block text-navy hover:text-orange transition-colors py-1 text-sm ${leaf.badge ? 'font-medium' : ''}`} data-id="element-198">
                                        {leaf.title} {renderBadge(leaf.badge)}
                                      </a>)}
                                  </div>
                                </div>)}
                            </div> : <div className="ml-4 space-y-2 mt-2" data-id="element-199">
                              {item.children.map(child => <a key={child.title} href={child.url} className="block text-navy hover:text-orange transition-colors py-1" data-id="element-200">
                                  {child.title}
                                </a>)}
                            </div>}
                        </>}
                    </div>;
            })}

                <div className="flex items-center space-x-4 pt-4 border-t border-gray-200" data-id="element-201">
                  <a href="https://www.linkedin.com/company/peak-machine-sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="LinkedIn" data-id="element-202">
                    <LinkedinIcon className="w-5 h-5" data-id="element-203" />
                  </a>
                  <a href="https://www.facebook.com/PeakMachineSales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Facebook" data-id="element-204">
                    <FacebookIcon className="w-5 h-5" data-id="element-205" />
                  </a>
                  <a href="https://www.instagram.com/peak_machine_sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Instagram" data-id="element-206">
                    <InstagramIcon className="w-5 h-5" data-id="element-207" />
                  </a>
                  <a href="https://www.youtube.com/channel/UCG3x08N2riAd1G2e9-driYA" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="YouTube" data-id="element-208">
                    <YoutubeIcon className="w-5 h-5" data-id="element-209" />
                  </a>
                </div>
              </nav>
            </div>}
        </div>
      </header>
    </>;
}